import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { NonDatasourceFieldDetailsFragmentGql } from './NonDatasourceFieldDetailsFragmentGql';

export const FieldDetailsFragmentGql: DocumentNode = gql`
fragment FieldDetailsFragment on Field {
  ...NonDatasourceFieldDetailsFragment
  ... on DatasourceField {
    datasourceField: id
    remoteField {
      datasource {
        name
        ... on PublishedDatasource {
          vizportalUrlId
        }
      }
      ...NonDatasourceFieldDetailsFragment
    }
  }
}
${NonDatasourceFieldDetailsFragmentGql}
`;
